/**
 * API service for the RCC Visual Flow Map
 */
import {
    GetProcessFlowMapDataInput,
    GetProcessFlowMapDataOutput,
    GetProcessFlowMetricsDataInput,
    GetProcessFlowMetricsDataOutput,
} from './model';
import { API_GATEWAY_PROCESS_NAME } from '../../../utils/constants';
import { apiRequest } from '../../../services/apiMiddleware';
import { store } from '../../../store';
import { selectStationCode } from '../../../store/slices/shiftPlanSlice';
import {
    logOperationalMetric,
    MetricType,
    RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB,
    GET_PROCESS_FLOW_MAP_DATA_API,
    GET_PROCESS_FLOW_METRICS_DATA_API,
} from '../../../utils/metric-utils';

/**
 * Fetch the Visual Flow Map topology: process-path nodes, the directed flow edges between
 * them, and the support (indirect) paths.
 */
export const getProcessFlowMapData = async (
    request: GetProcessFlowMapDataInput
): Promise<GetProcessFlowMapDataOutput> => {
    const startTime = Date.now();
    const stationCode = selectStationCode(store.getState()) || '';
    const requestPayload = {
        resourcePath: '/getProcessFlowMapData',
        httpMethod: 'post',
        processName: API_GATEWAY_PROCESS_NAME,
        requestBody: request,
    };
    try {
        const response = await apiRequest(requestPayload);
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_PROCESS_FLOW_MAP_DATA_API, MetricType.SUCCESS);
        return response.data;
    } catch (error: any) {
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_PROCESS_FLOW_MAP_DATA_API, MetricType.FAILED, error);
        throw error;
    }
};

/**
 * Fetch the Visual Flow Map metrics: the per-path Andon cards, the top-level Andon summary,
 * and the support (indirect) path metrics.
 */
export const getProcessFlowMetricsData = async (
    request: GetProcessFlowMetricsDataInput
): Promise<GetProcessFlowMetricsDataOutput> => {
    const startTime = Date.now();
    const stationCode = selectStationCode(store.getState()) || '';
    const requestPayload = {
        resourcePath: '/getProcessFlowMetricsData',
        httpMethod: 'post',
        processName: API_GATEWAY_PROCESS_NAME,
        requestBody: request,
    };
    try {
        const response = await apiRequest(requestPayload);
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_PROCESS_FLOW_METRICS_DATA_API, MetricType.SUCCESS);
        return response.data;
    } catch (error: any) {
        logOperationalMetric(startTime, stationCode, RCC_SHIFT_PLAN_FLOW_PLANNING_DASHBOARD_TAB, GET_PROCESS_FLOW_METRICS_DATA_API, MetricType.FAILED, error);
        throw error;
    }
};
